import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-white" data-id="element-39" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6 sm:py-20" data-id="element-40" data-mp="1o33u6h0ytshr">
        <div className="flex flex-col gap-6 rounded-2xl border-2 border-lime-400 bg-sand p-7 sm:flex-row sm:items-start sm:gap-8 sm:p-10" data-id="element-41" data-mp="223og3m26g4fh">
          <ShieldCheckIcon className="h-12 w-12 shrink-0 text-lime-600" strokeWidth={1.75} aria-hidden="true" data-id="element-42" data-mp="1x54ob50wjyf7" />
          <div data-id="element-43" data-mp="14gfn75zujt3g">
            <h2 className="font-display text-2xl font-extrabold tracking-tight text-navy-950 sm:text-3xl" data-id="element-44" data-mp="14gz3yjdrgbfw">
              Garantía de satisfacción total de 7 días
            </h2>
            <p className="mt-3 text-base leading-relaxed text-navy-800/85 sm:text-lg" data-id="element-45" data-mp="1edk9r6xltqks">
              Si después de leer la guía y aplicarla en tus próximos 3 partidos no sientes que tu
              nivel subió un escalón, te devolvemos el 100% de tu dinero. Sin preguntas.
            </p>
            <p className="mt-3 font-display font-bold text-navy-950" data-id="element-46" data-mp="p01iobo419bu">El riesgo es todo nuestro.</p>
          </div>
        </div>
      </div>
    </section>;
}